import type { IconData } from '@stacksjs/iconify-core'

export const unorderedList: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2m0 8h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2m0-4h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2M1 0a1 1 0 1 1 0 2a1 1 0 0 1 0-2m0 8a1 1 0 1 1 0 2a1 1 0 0 1 0-2m0-4a1 1 0 1 1 0 2a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default unorderedList
